import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import SellerLayout from './components/SellerLayout';
import HomePage from './components/PartnerComponents/HomePage';
import VerifyModal from './components/PartnerComponents/VerifyModal';
import AccountVerificationScreen from './components/PartnerComponents/AccountVerification';
import { toast } from 'react-toastify';

const Partner = () => {
  const [showModal, setShowModal] = useState(false);
  const [verified, setVerified] = useState(false);
  const [verificationInProgress, setVerificationInProgress] = useState(false);
  const [user, setUser] = useState(null);
  const [verificationCode, setVerificationCode] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const response = await api.get('/user/getuserdetails');
        setUser(response.data);
        if (response.data.phone_verified === true) {
          setVerified(true);
        }
      } catch (err) {
        toast.error(err.response?.data?.error || 'Greška prilikom učitavanja korisničkih podataka');
      }
    };
    fetchUser();
  }, []);

  useEffect(() => {
    if (verified) {
      navigate('/home-page');
    }
  }, [verified, navigate]);

  const handleVerification = async () => {
    setShowModal(false);
    setVerificationInProgress(true);

    if (!verificationCode || !user?.userid) {
      alert('Unesite validan verifikacioni kod.');
      setVerificationInProgress(false);
      return;
    }

    try {
      const response = await api.post('/user/verify-phone-number', {
        userid: user.userid,
        verificationCode: verificationCode,
      });

      if (response.data?.phone_verified) {
        setVerified(true);
      }

      setVerificationInProgress(false);
    } catch (err) {
      toast.error(err.response?.data?.error || 'Došlo je do greške prilikom verifikacije');
      setVerificationInProgress(false);
      setShowModal(true);
    }
  };

  const handleSendCode = async () => {
    if (!user?.phone || !user?.userid) {
      console.error("Nedostaju podaci za korisnika:", user);
      return;
    }

    try {
      await api.post('/user/send-phone-verification', { userid: user.userid, phone: user.phone });
    } catch (err) {
      toast.error("Greška prilikom slanja verifikacije");
    }
  };

  return (
    <div className="partner" style={styles.pageContainer}>
      <SellerLayout>
        <div style={styles.titleStyle}>Naslovna strana</div>
        {verificationInProgress ? (
          <AccountVerificationScreen />
        ) : !verified ? (
          <>
            <HomePage
              user={user}
              onClick={() => {
                setShowModal(true);
                handleSendCode();
              }}
            />
            {showModal && (
              <VerifyModal
                onClose={() => setShowModal(false)}
                onVerify={handleVerification}
                onCodeChange={(e) => setVerificationCode(e.target.value)}
              />
            )}
          </>
        ) : null}
      </SellerLayout>
    </div>
  );
};

export default Partner;

const styles = {
  pageContainer: {
    backgroundColor: '#FFF',
    minHeight: '100vh',
  },
  titleStyle: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '34px',
    fontWeight: 400,
    letterSpacing: '0.25px',
    lineHeight: '42px',
    marginBottom: '40px',
    marginLeft: '20px',
  },
};
